import React from 'react';

interface ModuleColumnProps {
  module: string;
}

export default React.memo((props: ModuleColumnProps) => {
  return <>{props.module}</>;
});
